import { createStore, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk';
import reducer, { State } from '../reducers';
import { loadState, saveState } from '../utils/localStorage';
import { throttle } from 'lodash';
import * as axiosConfig from './axiosConfig';

// Extend Window interface for Redux DevTools
declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: any;
    __REDUX_DEVTOOLS_EXTENSION__?: any;
  }
}
// Load State
const persistedState = loadState();

// Apply Middlewares — use thunk only; Redux DevTools browser extension handles inspection
const middleware = applyMiddleware(thunk);

// Create store with Redux DevTools support
const composeEnhancers = process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ 
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ 
  : (f: any) => f;

const store : any = createStore(
  reducer, 
  persistedState, 
  composeEnhancers(middleware)
);

// Make store available globally for debugging
if (process.env.NODE_ENV === 'development') {
  (window as any).store = store;
}

// Save state when there are changes
store.subscribe(
  throttle(
    () => {
      const state : State = store.getState() as State;
      saveState({ authentication: state.authentication });
    },
    1000,
  ),
);
// Set token into axios headers
const currentState: State = store.getState() as State;
axiosConfig.setToken(currentState.authentication.token || '');

// Auto-logout on 401: clear auth state so PrivateRoute redirects to login
axiosConfig.setOnUnauthorized(() => {
    store.dispatch({ type: 'LOGOUT' });
});

// Fetch user profile if we have a user, but handle backend connectivity issues gracefully
// TODO: Re-enable when /v1/users/{id} endpoint is implemented in backend
// if (currentState.authentication.user && currentState.authentication.token) {
//   // Wrap in try-catch to handle backend connectivity issues
//   store.dispatch(fetchUserProfile(currentState.authentication.user.id)).catch((error: any) => {
//     console.warn('Could not fetch user profile - backend may be down:', error);
//     // Don't fail the app initialization if backend is down
//   });
// }

export default store;
